import React, { useState } from 'react';
import styled from 'styled-components';
import { useImageUrl } from '../../hooks/useImageUrl';

const Image = styled.img`
  width: 64px;
  height: 64px;
  border-radius: 16px;
  object-fit: cover;
  background: #f9fafb;
  flex-shrink: 0;
`;

const Placeholder = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background: #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
  flex-shrink: 0;
  
  i {
    font-size: 1.8rem;
  }
`;

interface CartItemImageProps {
  imageId: string;
  alt: string;
}

export const CartItemImage: React.FC<CartItemImageProps> = ({ imageId, alt }) => {
  const imageUrl = useImageUrl(imageId);
  const [hasError, setHasError] = useState(false);

  if (!imageId || !imageUrl || hasError) {
    return null;
  }

  return (
    <Image 
      src={imageUrl} 
      alt={alt}
      onError={() => setHasError(true)}
    />
  );
};
